// lib/do-follow-domains.ts

/**
 * A list of external domains that should be treated as "followed" links for SEO purposes.
 * Any external link pointing to a domain NOT in this list will automatically have
 * `rel="nofollow"` added to it.
 *
 * @example
 * export const followedDomains = [
 *   'my-other-company-site.com',
 *   'our-trusted-partner.com',
 * ]
 */
export const followedDomains: string[] = [
  // Add trusted domains here
  'heyboss.ai',
  'heyboss.xyz',
  'heybossai.com',
  'heyboss.tech',
  'heyboss.live',
]
